export default {
  pages: {
    key: "title",
    data: [
      {
        url: "/",
        title: "Acceuil",
        is_bookmarked: true,
        icon: "HomeIcon",
      },
      {
        url: "/users",
        title: "Administrateurs",
        is_bookmarked: true,
        icon: "UsersIcon",
      },
      /*{
        url: "/settings",
        title: "Paramètres",
        is_bookmarked: true,
        icon: "SettingsIcon",
      },*/
    ]
  }
}
